import React from "react";
import { Tabs } from "antd";
import SuperAdminLayout from "../../layout/SuperAdminLayout";
import MerchantList from "./merchant";
import Adjustment from "./adjustment";

const Merchants = () => {
  const items = [
    {
      key: "1",
      label: `Merchant`,
      children: <MerchantList />,
    },
    {
      key: "2",
      label: `Adjustment`,
      children: <Adjustment />,
    },
  ];

  return (
    <SuperAdminLayout>
      <Tabs defaultActiveKey="1" items={items} />
    </SuperAdminLayout>
  );
};

export default Merchants;
